import { ColumnSortDirections } from '../../components/table/TableColumnSort.tsx';
import { type IPaginable } from './IPaginable.ts';

export interface IPaginationInput {
  page?: number;
  pageSize?: number;
  sort?: string | null;
  direction?: ColumnSortDirections | null;
}

/**
 * Funzione per creare l'oggetto "paginazione" utile per le chiamate API.
 */
export function getPagination(input: IPaginationInput): IPaginable {
  return {
    pagina: input.page === 0 ? 0 : (input.page ?? 1) - 1,
    limite: input.pageSize ?? 0,
    ordinamenti:
      input.sort && input.direction
        ? [
            `${input.direction === ColumnSortDirections.descend ? '-' : ''}${
              input.sort
            }`,
          ]
        : undefined,
  };
}
